export default __webpack_public_path__ + "static/media/download.0bea5f59.svg";